/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Habit_LeadInputs */

const en_for_whom_habit_lead = /** @type {(inputs: For_Whom_Habit_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fit, every day.`)
};

const pl_for_whom_habit_lead = /** @type {(inputs: For_Whom_Habit_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma na co dzień.`)
};

/**
* | output |
* | --- |
* | "Fit, every day." |
*
* @param {For_Whom_Habit_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_habit_lead = /** @type {((inputs?: For_Whom_Habit_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Habit_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_habit_lead(inputs)
	return en_for_whom_habit_lead(inputs)
});